export const load = () => ({
	title: 'Indow Window Insert Reviews',
	showTitle: true,
});
